import { AfterViewChecked, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { LocalizationService } from '../../services/localization.service';
import { WSServiceChatMessage } from '../pg-chat.model';

@Component({
    selector: 'app-pg-chat-channel',
    templateUrl: './pg-chat-channel.component.html',
    styleUrls: ['./pg-chat-channel.component.scss'],
    standalone: false
})
export class PgChatChannelComponent implements AfterViewChecked {

    constructor(private localizationService:LocalizationService) {}

    /** When false, only the empty shell is shown (waiting for channel_status). */
    @Input() ready = false;

    @Input() messages:Array<WSServiceChatMessage> = [];

    @Input() typing:{ [user:string]: number } = null;

    @Input() resolveUserName:(id:string) => string = (id) => id;

    @Input() allowAttachments = true;

    @Input() disabled = false;

    @Input() showHeader = true;

    /** Set true to scroll messages to bottom on next view check. */
    @Input()
    set scrollToBottom(val:boolean) {
        if(val) this._scrollToBottom = true;
    }

    @Output() sendMessage = new EventEmitter<string>();
    @Output() typingChange = new EventEmitter<boolean>();
    @Output() filesSelected = new EventEmitter<{ files:Array<File>, text:string }>();

    editMessageText = '';

    private _lastTypingTime = 0;
    private _scrollToBottom = true;

    @ViewChild('messagesElement') messagesElement:ElementRef;

    ngAfterViewChecked() {
        if(this._scrollToBottom && this.messagesElement != null) {
            this._scrollToBottom = false;
            let _el = this.messagesElement.nativeElement;
            _el.scrollTop = _el.scrollHeight - _el.offsetHeight;
        }
    }

    /** Call from parent when a new message arrives while stuck to bottom. */
    requestScrollToBottom(force?:boolean) {
        if(force) {
            this._scrollToBottom = true;
            return;
        }
        if(this.messagesElement != null) {
            let _el = this.messagesElement.nativeElement;
            if(_el.scrollTop >= _el.scrollHeight - _el.offsetHeight) {
                this._scrollToBottom = true;
            }
        }
        else {
            this._scrollToBottom = true;
        }
    }

    getMessageTime(message:WSServiceChatMessage) {
        return this.localizationService.format.time(message.time);
    }

    getMessageDate(message:WSServiceChatMessage) {
        return this.localizationService.format.date(message.time);
    }

    hasMessageDate(messages:Array<WSServiceChatMessage>, index:number) {
        if(index == 0) return true;
        return this.getMessageDate(messages[index]) != this.getMessageDate(messages[index - 1]);
    }

    hasMessageUserAndTime(messages:Array<WSServiceChatMessage>, index:number) {
        if(index == 0) return true;
        if(messages[index].from != messages[index - 1].from) return true;
        return this.getMessageTime(messages[index]) != this.getMessageTime(messages[index - 1]);
    }

    onEditMessageTextKeyUp(event:KeyboardEvent) {
        if(this.disabled) return;

        if(event.key == 'Enter' && this.editMessageText != '') {
            let _text = this.editMessageText;
            this.editMessageText = '';
            this.sendMessage.emit(_text);
            this.typingChange.emit(false);
        }
        else {
            let _now = Date.now();
            if(this._lastTypingTime + 1000 < _now) {
                this._lastTypingTime = _now;
                this.typingChange.emit(true);
            }
        }
    }

    onFiles(files:Array<File>) {
        let _text = this.editMessageText;
        this.editMessageText = '';
        this.filesSelected.emit({ files: files, text: _text });
    }
}
